import type { Message } from "ai";

export const COPILOT_PROJECT_NAME = "interfaces";
export const COPILOT_REGISTRY_ID = "interfaces";
export const COPILOT_API_ROUTE_PATH = "/api/interfaces/copilot";

/**
 * See https://ai-toolkit.vercel.zapier.com/docs/observability
 */
export const COPILOT_FEEDBACK_API_ROUTE_PATH =
  "/api/interfaces/copilot/feedback";

export const COPILOT_LOAD_MESSAGES_API_ROUTE_PATH =
  /**
   * The ai-toolkit will append the `/${conversationId}/messages` to this path.
   */
  "/api/interfaces/copilot/conversations";

/**
 * The number is arbitrary.
 */
export const COPILOT_CLIENT_TOOLS_MAX_STEPS = 10;

export const COPILOT_CONVERSATION_ID_QUERY_PARAM = "conversationId";

export const COPILOT_NEW_INTERFACE_NAME_QUERY_PARAM = "name";

/**
 * The default name is arbitrary.
 */
export const COPILOT_NEW_INTERFACE_DEFAULT_PROJECT_NAME = "New Interface";

/**
 * The default name is arbitrary.
 */
export const COPILOT_NEW_INTERFACE_DEFAULT_PAGE_NAME = "Page";

export const NEW_FROM_COPILOT_ROUTE_PATHNAME = "/interfaces/new-from-copilot";

export const TOOL_NAMES = {
  ADD_BLOCKS: "addBlocks",
  CONFIGURE_NAVIGATION: "configureNavigation",
  CREATE_PAGES: "createPages",
  CREATE_TABLE_FIELDS: "createTableFields",
  CREATE_TABLES_WITH_FIELDS_AND_RECORDS: "createTablesWithFieldsAndRecords",
  CREATE_ZAPS: "createZaps",
  GET_TABLES_FIELDS: "getTablesFields",
  SEARCH_HELP_DOCS: "searchHelpDocs",
  SEARCH_TABLES_BY_NAME: "searchTablesByName",
  TABLE_PICKER: "tablePicker",
  UPDATE_BLOCK: "updateBlock",
  UPDATE_CUSTOM_DOMAIN: "updateCustomDomain",
  UPDATE_FOCUS: "updateFocus",
  UPDATE_INTERFACE: "updateInterface",
  UPDATE_INTERFACE_SLUG: "updateInterfaceSlug",
  UPDATE_PAGE: "updatePage",
  UPDATE_THEME: "updateTheme",
  UPSERT_AI_GENERATED_COMPONENT: "upsertAIGeneratedComponent",
} as const;

export type ToolName = (typeof TOOL_NAMES)[keyof typeof TOOL_NAMES];

/**
 * 1. Block => Component to match our UI.
 * 2. We want to keep the display names succinct and to the point.
 */
export const TOOL_DISPLAY_NAMES = {
  addBlocks: "Add Components",
  configureNavigation: "Configure Navigation",
  createPages: "Create Pages",
  createTableFields: "Create Table Fields",
  createTablesWithFieldsAndRecords: "Create Tables",
  createZaps: "Create Zaps",
  getTablesFields: "Get Tables Fields",
  searchHelpDocs: "Search Help Docs",
  searchTablesByName: "Search Tables",
  tablePicker: "Pick a Table",
  updateBlock: "Update Component",
  updateCustomDomain: "Update Custom Domain",
  updateFocus: "Update Focus",
  updateInterface: "Update Interface",
  updateInterfaceSlug: "Update Interface Slug",
  updatePage: "Update Page",
  updateTheme: "Update Theme",
  upsertAIGeneratedComponent: "Upsert AI Generated Component",
} satisfies Record<ToolName, string>;

export const INITIAL_COPILOT_MESSAGE: Message = {
  id: "welcome",
  role: "assistant",
  content:
    "Hi! I can help you manage your interfaces. Try asking me questions about your interfaces!",
  createdAt: new Date(),
};
